import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationService } from '../../../services/organization.service';
import { NotificationService } from '../../../services/notification.service';
import { WatchOrganizationService } from '../../../services/watch-organization.service';
import { GlobalWindow } from '../../../main.window';

declare let window: GlobalWindow;

@Component({
  selector: '[organization-layout]',
  template: require('./organization-layout.component.pug'),
  styles: [require('./organization-layout.component.css').toString()],
})
export class OrganizationLayoutComponent implements OnInit, OnDestroy {
  routesub: any = null;
  sub: any = null;
  online: boolean = true;

  // -------------------------------------------------------------------
  constructor(
    private route: ActivatedRoute,
    private organization_service: OrganizationService,
    private notificationService: NotificationService,
    private watch: WatchOrganizationService,
  ) {
    this.sub = notificationService.networkStatus().subscribe(status => {
      this.online = status;
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.routesub = this.route.paramMap.subscribe(params => {
      let org_id = params.get('org_id');
      this.organization_service.setOrganizationId(org_id);
      this.watch.organizationId().next(org_id);
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.routesub) {
      this.routesub.unsubscribe();
    }
  }

  // -------------------------------------------------------------------
  envClass() {
    let newClass = {};

    newClass[window.env] = true;

    return newClass;
  }
}
